module.exports = __webpack_public_path__ + "img/Tanzania.cec90c30.gif";